@if (playerStatistics || matchActions) {
<div class="table-sport__cell table-sport__cell--info">
    @if (+playerStatistics?.total_goals > 0 || +playerStatistics?.GoalsScored > 0 || matchActions?.GOAL) {
    <span class="circle-info" data-toggle="tooltip" data-placement="top" title="{{ 'web.goal' | translate }}">
        <img src="img/sports/{{ sportName }}.png" alt="{{ 'sport.' + sportName | translate }}" width="14" />
        @if (+playerStatistics?.total_goals > 1 || +playerStatistics?.GoalsScored > 1 || matchActions?.GOAL?.length > 1)
        {
        <span class="badge badge-primary rounded-circle">{{
            playerStatistics?.total_goals || playerStatistics?.GoalsScored || matchActions.GOAL.length
        }}</span>
        }
    </span>
    } @if (pointsGoal && pointsGoal > 0) {
    <span
        class="circle-info"
        data-toggle="tooltip"
        data-placement="top"
        title="{{ 'web.' + sportName + '_goal' | translate }}"
    >
        <img src="img/sports/{{ sportName }}.png" alt="{{ 'sport.' + sportName | translate }}" width="14" />
        @if (pointsGoal > 0) {
        <span class="badge badge-primary rounded-circle">{{ pointsGoal }}</span>
        }
    </span>
    } @if ((playerStatistics?.total_plus_minus && playerStatistics?.total_plus_minus != 0) ||
    (playerStatistics?.PlusMinus && playerStatistics?.PlusMinus != 0)) {
    <span class="circle-info" data-toggle="tooltip" data-placement="top" title="{{ 'web.plus_minus' | translate }}"
        >+/-
        <span class="badge badge-primary rounded-circle">{{
            playerStatistics?.total_plus_minus || playerStatistics?.PlusMinus
        }}</span>
    </span>
    } @if ((playerStatistics?.total_assists && playerStatistics?.total_assists != 0) || (playerStatistics?.Assists &&
    playerStatistics?.Assists != 0) || matchActions?.ASSIST) {
    <span class="circle-info" data-toggle="tooltip" data-placement="top" title="{{ 'web.assistance' | translate }}"
        >A @if (+playerStatistics?.total_assists > 0 || +playerStatistics?.Assists > 0 || matchActions?.ASSIST?.length >
        0) {
        <span class="badge badge-primary rounded-circle">{{
            playerStatistics?.total_assists || playerStatistics?.Assists || matchActions.ASSIST.length
        }}</span>
        }
    </span>
    } @if ((playerStatistics?.YellowCards && playerStatistics?.YellowCards != 0) || matchActions?.YELCARD) {
    <span class="circle-info" data-toggle="tooltip" data-placement="top" title="{{ 'web.yellow_card' | translate }}">
        <svg class="icon icon--12 icon--yellow" id="yellow-card"><use href="#icon-card-yellow" /></svg>
    </span>
    } @if (redCardStats || matchActions?.REDCARD || matchActions?.YELLOW_RED_CARD) {
    <span class="circle-info" data-toggle="tooltip" data-placement="top" title="{{ 'web.red_card' | translate }}">
        <svg class="icon icon--12 icon--danger" id="red-card"><use href="#icon-card-yellow" /></svg>
    </span>
    } @if (playedTime !== false) {
    <span
        class="circle-info"
        [class.circle-info--up]="playerStatistics?.SubstitutedIn == 1"
        [class.circle-info--down]="playerStatistics?.SubstitutedOut == 1"
        data-toggle="tooltip"
        data-placement="top"
        title="{{ 'web.field_time' | translate }}"
    >
        {{ playedTime }}'
    </span>
    }
    <!-- <span
        *ngIf="
            !playerStatistics?.MinutesPlayed &&
            (playerStatistics?.SubstitutedIn == 1 || playerStatistics?.SubstitutedOut == 1)
        "
        class="circle-info"
        [class.circle-info--up]="playerStatistics?.SubstitutedIn == 1"
        [class.circle-info--down]="playerStatistics?.SubstitutedOut == 1"
        data-toggle="tooltip"
        data-placement="top"
        title="{{ 'web.substitution' | translate }}"
        >
        {{ substitutedIn ? substitutedIn : substitutedOut ? substitutedOut : '-' }}
      </span> -->
    @if (matchActions?.SUBS) { @for (matchAction of matchActions.SUBS; track $index) {
    <span
        class="circle-info circle-info--{{ matchAction.matchActionType === 'SUBS_UP' ? 'up' : 'down' }}"
        data-toggle="tooltip"
        data-placement="top"
        title="{{ 'web.substitution' | translate }}"
        >{{ matchAction.minute }}'</span
    >
    } }
</div>
}
